import { treemap, hierarchy, treemapSquarify, } from "d3-hierarchy";
export var calculateTreeMap = function (_a) {
    var width = _a.width, height = _a.height, data = _a.data, valuePropInData = _a.valuePropInData, paddingOuter = _a.paddingOuter, paddingInner = _a.paddingInner;
    return treemap()
        .tile(treemapSquarify.ratio(1))
        .size([width, height])
        .round(true)
        .paddingOuter(paddingOuter)
        .paddingInner(paddingInner)
        .paddingTop(22)(hierarchy(data)
        .sum(function (s) { return s[valuePropInData]; })
        .sort(function (a, b) { return b[valuePropInData] - a[valuePropInData]; }));
};
